
import { defineComponent } from "vue";

function defaultOptions() {
  return {
    contactUpdate: {
      askForEmail: false,
      askForPhone: false
    },
    imageReading: {
      enabled: false
    },
    audioReading: {
      enabled: false
    },
    followUp: {
      continueOnEmail: false,
      includeColdLeads: false
    }
  };
}

export default defineComponent({
  name: "ai-agent-options-panel",
  props: {
    modelValue: {
      type: Object,
      default: () => defaultOptions()
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      selectedOption: "contactUpdate",
      syncingFromParent: false,
      options: defaultOptions(),
      optionItems: [
        { key: "contactUpdate", label: "Contact Update", disabled: false },
        { key: "imageReading", label: "Image Reading", disabled: false },
        { key: "audioReading", label: "Audio Reading", disabled: false }
      ]
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      deep: true,
      handler(value) {
        const next = this.normalizeOptions(value);
        if (this.optionsEqual(next, this.options)) {
          return;
        }
        this.syncingFromParent = true;
        this.options = next;
        this.syncingFromParent = false;
      }
    },
    options: {
      deep: true,
      flush: "sync",
      handler(value) {
        if (this.syncingFromParent) {
          return;
        }
        const next = this.normalizeOptions(value);
        if (this.optionsEqual(next, this.modelValue)) {
          return;
        }
        this.$emit("update:modelValue", JSON.parse(JSON.stringify(next)));
      }
    }
  },
  methods: {
    optionsEqual(left: any, right: any) {
      return JSON.stringify(this.normalizeOptions(left))
        === JSON.stringify(this.normalizeOptions(right));
    },
    normalizeOptions(input: any) {
      const base = defaultOptions();
      const source = input && typeof input === "object" ? input : {};
      const contactUpdate = source.contactUpdate || {};
      const imageReading = source.imageReading || {};
      const audioReading = source.audioReading || {};
      const followUp = source.followUp || {};
      return {
        contactUpdate: {
          askForEmail: Boolean(contactUpdate.askForEmail),
          askForPhone: Boolean(contactUpdate.askForPhone)
        },
        imageReading: {
          enabled: Boolean(imageReading.enabled)
        },
        audioReading: {
          enabled: Boolean(audioReading.enabled)
        },
        followUp: {
          continueOnEmail: Boolean(followUp.continueOnEmail),
          includeColdLeads: Boolean(followUp.includeColdLeads)
        }
      };
    },
    selectOption(item: any) {
      if (item.disabled) return;
      this.selectedOption = item.key;
    }
  }
});
